import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Authenticated requests — sends/receives cookies (used by /admin/* and /auth/*)
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Public requests — no credentials so Cloudflare's `Access-Control-Allow-Origin: *` is accepted by browsers
export const publicApi = axios.create({
  baseURL: API,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
